module.exports = __webpack_public_path__ + "img/凌烟阁清鉴集（黄庭坚体）白.24bffc56.png";